module.exports = __webpack_public_path__ + "static/media/founters-bg.1007f257.svg";